module.exports = __webpack_public_path__ + "static/img/The_library1.2cabd3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/The_library1.png
// module id = PXlY
// module chunks = 0